import { ONETRUST } from 'constants/common';
import { getCookie } from '@cat-ecom/common/utils/cookieUtils';

/**
 * Determine passed consent type is available in one trust consent cookie
 * @param {string} consentType one trust consent type
 * @returns
 */
export const isConsentTypeAvailable = (consentType?: string) => {
  const consentCookie =
    typeof document !== 'undefined'
      ? getCookie(ONETRUST.OPT_CONSENT_COOKIE)
      : null;
  return consentCookie?.includes(consentType) ?? false;
};
